import React, { Component } from "react";
const config = require("../config.json");

export default class Hygge extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    usersUnconfirmed: [],
    usersConfirmed: [],
    usersConfirmed24: [],
  };

  componentDidMount = () => {
    const now = new Date();
    const femogtyvende = new Date(Date.parse("02/25/2024"));
    now.setHours(now.getHours() - 2);
    const fireogtyvetimer = new Date();
    fireogtyvetimer.setHours(0);
    fireogtyvetimer.setDate(fireogtyvetimer.getDate() - 4);

    console.log("TOTAL COGNITO:", cognitodata.Users.length);

    const UNCONFIRMED = cognitodata.Users.filter(
      (user) =>
        user.UserStatus == "UNCONFIRMED" &&
        new Date(Date.parse(user.UserCreateDate)) > fireogtyvetimer
    );

    const CONFIRMED = cognitodata.Users.filter(
      (user) =>
        user.UserStatus == "CONFIRMED" &&
        new Date(Date.parse(user.UserCreateDate)) > now
    );

    const CONFIRMED24 = cognitodata.Users.filter(
      (user) =>
        user.UserStatus == "CONFIRMED" &&
        new Date(Date.parse(user.UserCreateDate)) > fireogtyvetimer
    );

    this.setState({ usersUnconfirmed: UNCONFIRMED });
    this.setState({ usersConfirmed: CONFIRMED });
    this.setState({ usersConfirmed24: CONFIRMED24 });
  };

  render() {
    return (
      <>
        <section className="section">
          <div style={{ flexDirection: "row" }} className="container">
            <div style={{}}>
              <div>
                AMOUNT UNCONFIRMED LAST 3 DAYS:
                {this.state.usersUnconfirmed.length}
              </div>
              <br></br>
              {this.state.usersUnconfirmed.map((user) => {
                const hygge = new Date(
                  Date.parse(user.UserCreateDate)
                ).toLocaleString();
                return (
                  <div>
                    <div>created: {hygge}</div>
                    <div>
                      {user.Attributes.map((attr) => {
                        if (attr.Name == "email")
                          return <span>{`${attr.Name}:  ${attr.Value}`}</span>;
                      })}
                    </div>

                    <br></br>
                  </div>
                );
              })}
            </div>
            <div style={{}}>
              <div>
                AMOUNT CONFIRMED LAST 2 HOURS:{" "}
                {this.state.usersConfirmed.length}
              </div>
              <br></br>
              {this.state.usersConfirmed
                .sort(function (a, b) {
                  return (
                    new Date(b.UserCreateDate) - new Date(a.UserCreateDate)
                  );
                })
                .map((user) => {
                  const hygge = new Date(
                    Date.parse(user.UserCreateDate)
                  ).toLocaleString();
                  return (
                    <div>
                      <div>created: {hygge}</div>
                      <div>
                        {user.Attributes.map((attr) => {
                          if (attr.Name == "email")
                            return (
                              <span>{`${attr.Name}:  ${attr.Value}`}</span>
                            );
                        })}
                      </div>

                      <br></br>
                    </div>
                  );
                })}
            </div>
            <div style={{}}>
              <div>
                AMOUNT CONFIRMED LAST 24 HOURS:{" "}
                {this.state.usersConfirmed24.length}
              </div>
              <br></br>
              {this.state.usersConfirmed24
                .sort(function (a, b) {
                  return (
                    new Date(b.UserCreateDate) - new Date(a.UserCreateDate)
                  );
                })
                .map((user) => {
                  const hygge = new Date(
                    Date.parse(user.UserCreateDate)
                  ).toLocaleString();
                  return (
                    <div>
                      <div>created: {hygge}</div>
                      <div>
                        {user.Attributes.map((attr) => {
                          if (attr.Name == "email")
                            return (
                              <span>{`${attr.Name}:  ${attr.Value}`}</span>
                            );
                        })}
                      </div>

                      <br></br>
                    </div>
                  );
                })}
            </div>
          </div>
        </section>
      </>
    );
  }
}
